/**
 * Scheduling Constants and Utilities
 * Shared constants and helper functions for scheduling components
 */

export const EVENT_TYPES = [
  { value: "practice", label: "Practice", color: "bg-blue-100 text-blue-700 border-blue-200" },
  { value: "game", label: "Game", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  { value: "tryout", label: "Tryout", color: "bg-violet-100 text-violet-700 border-violet-200" },
  { value: "meeting", label: "Meeting", color: "bg-amber-100 text-amber-700 border-amber-200" },
  { value: "blackout", label: "Blackout", color: "bg-rose-100 text-rose-700 border-rose-200" },
  { value: "other", label: "Other", color: "bg-slate-100 text-slate-700 border-slate-200" }
];

export const SPORT_OPTIONS = [
  { value: "soccer", label: "Soccer", type: "field" },
  { value: "football", label: "Football", type: "field" },
  { value: "baseball", label: "Baseball", type: "field" },
  { value: "softball", label: "Softball", type: "field" },
  { value: "lacrosse", label: "Lacrosse", type: "field" },
  { value: "basketball", label: "Basketball", type: "court" },
  { value: "tennis", label: "Tennis", type: "court" },
  { value: "volleyball", label: "Volleyball", type: "court" },
];

export const getEventTypeStyle = (type) => {
  return EVENT_TYPES.find(t => t.value === type)?.color || EVENT_TYPES[EVENT_TYPES.length - 1].color;
};
